import { listFeign } from '@/api/pm/table'
const state = {
    deptList:[]
}
const mutations = {
    SET_DEPTLIST(state, deptList) {
        state.deptList = deptList
      },
}
const actions = {
    getDeptList ({ commit }) {
        return new Promise((resolve, reject) => {
            listFeign().then(res=>{
                commit('SET_DEPTLIST', res.data)
            })
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
  }